import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import ResultHistory from "../ResultHistory/ResultHistory";
import { StyledBoard } from "./Board.styled";
import { useWindowSize } from "@uidotdev/usehooks";
import { useGameContext } from "../GameContext/GameContext";
var BoardBase = function (_a) {
    var children = _a.children, seedSettingsCalls = _a.seedSettingsCalls;
    var _b = useGameContext(), boardSize = _b.boardSize, setBoardSize = _b.setBoardSize;
    var boardRef = useRef(null);
    var windowSize = useWindowSize();
    useEffect(function () {
        var updateBoardSize = function () {
            if (boardRef.current) {
                var konvaContent = boardRef.current.querySelector('.konvajs-content');
                if (konvaContent) {
                    konvaContent.style.display = 'none';
                }
                setBoardSize({
                    width: boardRef.current.clientWidth,
                    height: boardRef.current.clientHeight
                });
                if (konvaContent) {
                    konvaContent.style.display = '';
                }
            }
        };
        updateBoardSize(); // Initial size
        window.addEventListener('resize', updateBoardSize); // Listen to resize
        return function () { return window.removeEventListener('resize', updateBoardSize); }; // Cleanup
    }, [windowSize, setBoardSize]);
    return (_jsxs(StyledBoard, { ref: boardRef, children: [_jsx(ResultHistory, { seedSettingsCalls: seedSettingsCalls }), (boardSize.width > 0 && boardSize.height > 0) &&
                _jsx(_Fragment, { children: children })] }));
};
export default BoardBase;
//# sourceMappingURL=Board.js.map